// voiceSearch.js
// Helper canônico para integrar speech recognition em handlers de busca.
// Antes vivia dentro do MainContainer.handleVoiceRecognition; com o drop do
// MainContainer (F5), foi extraído pra utility consumido pelo prop
// `onVoiceClick` do SearchBar/SearchFilterRow.
//
// Uso (em qualquer page com handleSearch):
//   onVoiceClick={makeVoiceHandler(this.handleSearch)}
//
// O handler chama SpeechRecognition (microphone API), pega o transcript em
// pt-BR, e simula um evento com target.value pra reusar o handleSearch
// existente sem refactor.

import SpeechRecognition from '../components/SpeechRecognition'

export function makeVoiceHandler(handleSearch) {
  return async () => {
    try {
      const transcript = await SpeechRecognition()
      if (transcript !== null && transcript !== undefined) {
        const evt = { target: { name: 'busca', id: 'busca', value: transcript } }
        handleSearch && handleSearch(evt, transcript)
        // Sincroniza o input visual — o TextField legacy usa id='busca'.
        const input = document.getElementById('busca')
        if (input) {
          input.value = transcript
        }
      }
    } catch (e) {
      console.log('[voiceSearch] error:', e)
    }
  }
}
